<template>
    <section>
        <div class="left">
          <detail-entity-info :entity="entity" v-if="entity.id">
            <p><translate class="translate">Počet operátorů</translate>: {{ entity.operators.length }}</p>
            <p><translate class="translate">Počet domén</translate>: {{ entity.domains.length }}</p>
          </detail-entity-info>
            <h2 v-else v-translate>Základní údaje</h2>
        </div>
        <div class="right">
            <div class="field_left">
              <text-input
                  id="name"
                  :required="true"
                  v-model="entity.name"
                  ref="nameref"
                  :disabled="!isEditable"
              ><translate class="translate">Název</translate></text-input>
            </div>
            <div class="field_right">
              <text-input
                  id="code"
                  :required="true"
                  v-model="entity.code"
                  ref="coderef"
                  :disabled="!isEditable"
              ><translate class="translate">Kód</translate></text-input>
            </div>
            <checkbox-input
                id="allowpairallbrands"
                v-model="entity.allow_pair_devices_from_other_brands_when_static_brand_configured"
                ref="allowpairallbrandsref"
                :disabled="!isEditable"
            >
              <translate class="translate">Povolit párování odběratelů ostatních brandů</translate>
            </checkbox-input>
            <textarea-input
                id="note"
                rows=6
                cols=50
                v-model="entity.note"
                :disabled="!isEditable"
            >
              <translate class="translate">Poznámka</translate>
            </textarea-input>
        </div>
    </section>
</template>

<script>
	import requiredFields from "@/components/mixins/required-fields"
  import DetailEntityInfo from "../../../common/DetailEntityInfo";

	export default {
		name: "BasicInfo",
    components: {DetailEntityInfo},
    mixins: [requiredFields],
		props: {
      isEditable: Boolean,
			entity: Object,
			errorMessages: {
				type: [Array, Object],
				default: function () {
					return []
				},
			},
		},
    methods: {
      validateFormRequiredFields() {
        let nameError = null;
        let codeError = null;

        if (!this.entity.name) {
          nameError = "Zadejte název"
        } else if (this.entity.name.length < 2) {
          nameError = "Název musí obsahovat alespoň 2 znaky"
        }

        if (!this.entity.code) {
          codeError = "Zadejte kód"
        } else if (this.entity.code.length < 2) {
          codeError = "Kód musí obsahovat alespoň 2 znaky"
        }

        if (nameError !== null) {
          this.setFieldInvalid('nameref', true, nameError)
        } else {
          this.setFieldInvalid('nameref');
        }

        if (codeError !== null) {
          this.setFieldInvalid('coderef', true, codeError)
        } else {
          this.setFieldInvalid('coderef');
        }
      }
    },
		computed: {
			requiredFields() {
				return [
					{'key': 'name', 'name': this.$gettext('Název')},
					{'key': 'code', 'name': this.$gettext('Kód')},
				]
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/brands/forms/BasicInfo.vue